import { render, staticRenderFns } from "./adminRenovacionPortalComercial.vue?vue&type=template&id=60292ced"
import script from "./adminRenovacionPortalComercial.vue?vue&type=script&lang=js"
export * from "./adminRenovacionPortalComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports